const RETURN_TO_KEY = 'fb_return_to';

export const sanitizeReturnTo = (value: string | null | undefined): string | null => {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  let decoded = trimmed;
  if (trimmed.includes('%') && !trimmed.startsWith('/')) {
    try {
      decoded = decodeURIComponent(trimmed);
    } catch {
      return null;
    }
  }
  if (!decoded.startsWith('/')) return null;
  if (decoded.startsWith('//')) return null;
  if (decoded.startsWith('/\\')) return null;
  return decoded;
};

export const storeReturnTo = (value: string | null | undefined) => {
  const safe = sanitizeReturnTo(value);
  if (!safe || typeof window === 'undefined') return;
  window.sessionStorage.setItem(RETURN_TO_KEY, safe);
};

export const peekReturnTo = (): string | null => {
  if (typeof window === 'undefined') return null;
  return sanitizeReturnTo(window.sessionStorage.getItem(RETURN_TO_KEY));
};

export const consumeReturnTo = (): string | null => {
  if (typeof window === 'undefined') return null;
  const safe = sanitizeReturnTo(window.sessionStorage.getItem(RETURN_TO_KEY));
  if (safe) window.sessionStorage.removeItem(RETURN_TO_KEY);
  return safe;
};

export const clearReturnTo = () => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(RETURN_TO_KEY);
};
